import { useCallback, useEffect, useState } from "react";
import { CheckCircle2, ShieldAlert } from "lucide-react";
import { PageHero, Loading } from "../../components/site/Blocks";
import DelegateVerify from "../../components/virtual/DelegateVerify";
import ZoomJoin from "../../components/virtual/ZoomJoin";
import { useTheatre } from "../../components/site/SiteLayout";
import { api } from "../../lib/api";
import { DELEGATE_KEY, delegateApi } from "../../lib/delegate";
import { useIsolationReload } from "../../lib/meeting";
import { formatEventDate } from "../../lib/format";

export default function VirtualJoin() {
  const { theatre } = useTheatre();
  const [status, setStatus] = useState(null);
  const [me, setMe] = useState(null);
  const [hasSession, setHasSession] = useState(!!sessionStorage.getItem(DELEGATE_KEY));

  useEffect(() => { api.get("/virtual/status").then((r) => setStatus(r.data)); }, []);
  useIsolationReload();
  const loadMe = useCallback(() => {
    delegateApi.get("/virtual/me").then((r) => setMe(r.data)).catch(() => { sessionStorage.removeItem(DELEGATE_KEY); setHasSession(false); });
  }, []);
  useEffect(() => { if (hasSession) loadMe(); }, [hasSession, loadMe]);
  const signOut = () => { sessionStorage.removeItem(DELEGATE_KEY); setMe(null); setHasSession(false); };

  return (
    <div data-testid="virtual-page">
      {!theatre && <PageHero eyebrow="VIRTUAL ATTENDANCE" title="Join Virtual Event" subtitle="Registered virtual delegates can join the live session here after verifying their registration." />}
      <section className={`container-site ${theatre ? "py-3" : "py-14"}`}>
        {!status ? <Loading /> : !hasSession ? <DelegateVerify status={status} onVerified={() => setHasSession(true)} /> : !me ? <Loading /> : (
          <div className="mx-auto max-w-4xl" data-testid="delegate-panel">
            <div className="flex flex-wrap items-start justify-between gap-4 border-b border-slate-200 pb-5">
              <div>
                <p className="text-sm text-[#4A5568]">Signed in as</p>
                <p className="text-xl font-semibold text-navy" data-testid="delegate-name">{me.delegate.name} <span className="font-mono text-sm text-[#4A5568]">{me.delegate.reference}</span></p>
                <p className="text-sm text-[#4A5568]">{me.event.name} · {formatEventDate(me.event)}{!me.event.date_confirmed && " (to be confirmed)"}</p>
              </div>
              <button type="button" className="text-sm font-semibold text-burgundy" onClick={signOut} data-testid="delegate-sign-out-btn">Sign out</button>
            </div>
            {me.eligible ? (
              <div className="mt-6">
                <p className="mb-5 flex items-center gap-2 font-semibold text-green-800" data-testid="delegate-eligible"><CheckCircle2 size={20} aria-hidden="true" /> Your virtual access is confirmed.</p>
                <ZoomJoin me={me} />
              </div>
            ) : (
              <p className="mt-6 flex items-start gap-3 rounded bg-paleblue p-5 text-navy" role="alert" data-testid="delegate-ineligible">
                <ShieldAlert className="shrink-0 text-burgundy" aria-hidden="true" />
                <span><b className="block">Virtual access not available</b>{me.message} <span className="text-xs text-[#4A5568]">(code: {me.reason})</span></span>
              </p>
            )}
          </div>
        )}
      </section>
    </div>
  );
}
